export enum HTTP_STATUS {
  OK = 200,
  NO_CONTENT = 204,

  BAD_REQUEST = 400,
  FORBIDDEN = 403,
  NOT_FOUND = 404,
  METHOD_NOT_ALLOWED = 405,

  NOT_IMPLEMENTED = 501,
}
